import React from "react";
import SeoHead from "../../components/SeoHead";
import Hero from "./Hero";
import Numbers from "./Numbers";
import Payments from "./Payments";
import BusinessType from "./BusinessType";
import Partners from "./Partners";
import Security from "./Security";
import Testimonial from "./Testimonial";
import Faq from "./Faq";
import Biometric from "./Biometric";

function Landing() {
  return (
    <>
      <SeoHead
        title="Business Payment Management Platform"
        description="Impala Digital Payments helps businesses pay staff, manage petty cash, and track expenses in real time. No spreadsheets, no losses. Bulk payments, supplier settlements and more."
        path="/"
      />
      <div className="hero-img-2 h-auto pt-[5rem]" id="home">
        <div className="lg:px-[5.69rem] px-3 lg:min-h-[47.125rem] min-h-auto">
          <Hero />
        </div>
      </div>
      <div className="bg-busines-type h-auto lg:pt-[7.75rem] pt-[3rem] pb-[1rem] lg:pb-[3.06rem]" id="numbers">
        <div className="lg:px-[5.69rem] px-3">
          <Numbers />
        </div>
      </div>
      <div className="bg-busines-type h-auto lg:pt-[3.44rem] py-3">
        <div className="lg:px-[5.69rem] px-3">
          <BusinessType />
        </div>
      </div>
      <div className="lg:px-[5.69rem] px-3 mt-[3rem] lg:mt-[6rem]">
        <Biometric />
      </div>
      <div className="lg:px-[5.69rem] px-3 lg:mt-[6rem] mt-[2rem]">
        <Payments />
      </div>
      <div className="lg:px-[5.69rem] px-3 mt-[4.97rem] bg-white">
        <Partners />
      </div>
      <div className="lg:px-[5.69rem] px-3 lg:mt-[5.03rem] mt-[2rem] py-[2.75rem] bg-secure w-full">
        <Security />
      </div>
      <div className="lg:px-[5.69rem] px-3 mt-[4.12rem] bg-white">
        <Testimonial />
      </div>
      <div className="bg-busines-type impala-corners h-auto lg:pt-[8.44rem] py-3" id="faq">
        <div className="lg:px-[5.69rem] px-3">
          <Faq />
        </div>
      </div>
    </>
  );
}

export default Landing;
